import React from 'react';
// components
import Banner from './components/Banner';
import Header from './components/Header';
import Nav from './components/Nav';
import About from './components/About';
import Services from './components/Services';
import Testimoni from './components/Testimoni';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Partner from './components/Partner';

const App = () => {
  return (
    <div className='bg-site bg-no-repeat bg-cover overflow-hidden'>
      <Header />
      <Banner />
      <Nav />
      <About />
      <Services />
      <Testimoni />
      <Partner/>
      <Contact />
     
      <Footer />
        <div className='h-[12vh] lg:h-0'></div>
    </div>
  );
};

export default App;
